import {
  Action,
  config,
  defaultProcessingSaga,
  defaultResponseProcessing,
  fetchAuthSaga,
  FetchResponse,
} from '@triare/auth-redux';
import {
  put, delay, takeLatest, call,
} from 'redux-saga/effects';
import { actions, SubCategory } from './index';

export type SubCategoryByIdData = SubCategory

export type SubCategoryByIdResponse = SubCategoryByIdData

export interface SubCategoryByIdParams {
  id: string;
}

export const subCategoryById = (payload: SubCategoryByIdParams): Action<SubCategoryByIdParams> => ({
  type: actions.subCategoryByIdTrigger.toString(),
  payload,
});

export const subCategoryByIdClear = (): Action => ({
  type: actions.subCategoryByIdClear.toString(),
});

export const subCategoryByIdErrorClear = (): Action => ({
  type: actions.subCategoryByIdErrorReset.toString(),
});

export function* subCategoryByIdRequestSaga({ payload }: Action<SubCategoryByIdParams>) {
  yield put({
    type: actions.subCategoryByIdStart.toString(),
  });

  if (!payload) {
    yield put({
      type: actions.subCategoryByIdError.toString(),
      payload: {
        message: 'SubCategoryById: Parameters not passed.',
      },
    });

    return;
  }

  const { id } = payload;

  const response = (yield call(
    fetchAuthSaga,
    `${process.env.REACT_APP_API}sub-categories/${id}`,
    {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
      },
    },
    {},
    config.fetchDelay,
  )) as FetchResponse;

  yield defaultResponseProcessing<SubCategory, SubCategory>(
    response,
    actions.subCategoryByIdSuccess.toString(),
    actions.subCategoryByIdError.toString(),
    false
  );
}

export default function* saga() {
  yield takeLatest(
    actions.subCategoryByIdTrigger.toString(),
    defaultProcessingSaga(
      subCategoryByIdRequestSaga,
      {
        error: actions.subCategoryByIdError.toString(),
        locationCancel: actions.subCategoryByIdClear.toString(),
      },
    ),
  );

  yield takeLatest(actions.subCategoryByIdSuccess.toString(), function* clear() {
    if (config.delaySuccess) {
      yield delay(config.delaySuccess);
    }
  });

  yield takeLatest(actions.subCategoryByIdError.toString(), function* errorReset() {
    if (config.delayError) {
      yield delay(config.delayError);
    }

    yield put({
      type: actions.subCategoryByIdErrorReset.toString(),
    });
  });
}
